import { render, staticRenderFns } from "./tentant.vue?vue&type=template&id=2436e20c&scoped=true&"
import script from "./tentant.vue?vue&type=script&lang=ts&"
export * from "./tentant.vue?vue&type=script&lang=ts&"
import style0 from "./tentant.vue?vue&type=style&index=0&id=2436e20c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2436e20c",
  null
  
)

export default component.exports